import {
  Component,
  TemplateRef,
  ViewChild,
  ViewEncapsulation,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { NzTabsModule } from 'ng-zorro-antd/tabs';
import { NzInputGroupComponent } from 'ng-zorro-antd/input';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzButtonModule } from 'ng-zorro-antd/button';
import {
  NzNotificationPlacement,
  NzNotificationService,
} from 'ng-zorro-antd/notification';
import { SvgIconComponent } from 'angular-svg-icon';
import { NzDropDownModule } from 'ng-zorro-antd/dropdown';
import { FormsModule } from '@angular/forms';
import { NzSelectModule } from 'ng-zorro-antd/select';
import {
  NzFormControlComponent,
  NzFormItemComponent,
  NzFormLabelComponent,
} from 'ng-zorro-antd/form';
import { UserListComponent } from './manage-user/user-list/user-list.component';
import { CustomResourcesComponent } from './custom-resources/custom-resources.component';
import { NzDrawerModule } from 'ng-zorro-antd/drawer';
import { SubscriptionListingComponent } from './subscriptions/subscription-listing/subscription-listing.component';
import { InsightsComponent } from './insights/insights.component';
import { DrawerService } from '../../core/services/drawer.service';
import { ManageOrganizationService } from './manage-organization.service';
import { AddUserComponent } from './manage-user/add-user/add-user.component';
import { DRAWER_IDS } from '../../core/constants/drawer-ids.constant';
import { SettingsComponent } from './settings/settings.component';
import { ManageOrganizationDrawerParams } from './manage-organization.interface';
import { Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'app-manage-organization',
  standalone: true,
  imports: [
    NzTabsModule,
    NzIconModule,
    UserListComponent,
    NzInputGroupComponent,
    NzButtonModule,
    SubscriptionListingComponent,
    InsightsComponent,
    SvgIconComponent,
    NzDropDownModule,
    FormsModule,
    NzSelectModule,
    NzFormItemComponent,
    NzFormLabelComponent,
    NzFormControlComponent,
    CustomResourcesComponent,
    SettingsComponent,
    NzDrawerModule,
    CommonModule,
  ],
  templateUrl: './manage-organization.component.html',
  styleUrl: './manage-organization.component.scss',
  encapsulation: ViewEncapsulation.None,
})
export class ManageOrganizationComponent {
  @ViewChild('footerTpl') footerTpl!: TemplateRef<void>;
  placement: NzNotificationPlacement = 'top';
  selectedTabIndex = 0; // Default to the first tab
  @ViewChild(SubscriptionListingComponent)
  subscriptionComponent!: SubscriptionListingComponent;
  searchTerm = '';
  isExportUsers = false;
  private readonly destroy$ = new Subject<void>();
  orgParams: ManageOrganizationDrawerParams | null = null;

  constructor(
    private readonly notification: NzNotificationService,
    private readonly drawerService: DrawerService,
    private readonly manageOrgService: ManageOrganizationService
  ) {
    this.manageOrgService.searchSubject.next({ searchTerm: '', tabIndex: 0 });
    this.setupDrawerParams();
  }

  selectTab(index: number): void {
    this.selectedTabIndex = index;
  }

  private setupDrawerParams(): void {
    this.drawerService
      .getParams<ManageOrganizationDrawerParams>(DRAWER_IDS.MANAGE_ORG)
      .pipe(takeUntil(this.destroy$))
      .subscribe(params => {
        if (params) {
          this.orgParams = params;
        }
      });
  }

  addNewSubscription() {
    this.subscriptionComponent.addSubscription();
  }

  createNotification(type: string): void {
    this.notification.create(type, 'User has been moved successfully', '', {
      nzPlacement: this.placement,
      nzDuration: 3000,
    });
  }

  openAddUserDrawer(): void {
    this.drawerService.openDrawer(
      AddUserComponent,
      'Add User',
      520,
      true,
      undefined,
      undefined,
      DRAWER_IDS.USER
    );
  }
  transferDrawerVisible = false;
  openTransferDrawer(): void {
    this.transferDrawerVisible = true;
  }

  closeTansferDrawer(): void {
    this.transferDrawerVisible = false;
  }
  selectedValue = null;

  onSearch(): void {
    this.manageOrgService.searchSubject.next({
      searchTerm: this.searchTerm,
      tabIndex: this.selectedTabIndex,
    });
  }
}
